<app-page-content-wrapper [goBack]="goBack.bind(this)">
  <div class="page-title mb-3">
    <div class="container px-0">
      <div class="row">
        <div class="col-12 col-md-9 text-start"><h2>Box Design Collaboration Service</h2></div>
        <div class="d-none d-md-inline col-md-3 text-end">
          <button class="orange-submit" (click)="scrollToBottom()">GET STARTED</button>
        </div>
      </div>
    </div>
  </div>
  <div class="cta-block purple-background mt-1">
    <div class="cta-background-container"></div>
    <div class="container content-container">
      <div class="row">
        <div class="col-6 col-lg-3 text-center mb-3 mb-lg-1">
          <img src="/assets/fedex/images/create.jpg" class="promo-image p-3" alt="" />
          <h5>Create from the very start</h5>
          <br />
          Whether you have inspirational pictures or sketches, we have the expertise to transform your ideas into unique
          packaging.
        </div>

        <div class="col-6 col-lg-3 text-center mb-3 mb-lg-1">
          <img src="/assets/fedex/images/refresh.jpg" class="promo-image p-3" alt="" />
          <h5>Refreshing your brand</h5>
          <br />
          Collaborate one-on-one with us to enhance your current branding.
        </div>

        <div class="col-6 col-lg-3 text-center mb-3 mt-2 mb-lg-1 mt-lg-0">
          <img src="/assets/fedex/images/launch.jpg" class="promo-image p-3" alt="" />
          <h5>Launch new campaigns</h5>
          <br />
          Our creative team will harness the power of design to convey your brand's unique position in the market
          effectively.
        </div>

        <div class="col-6 col-lg-3 text-center mb-3 mt-2 mb-lg-1 mt-lg-0">
          <img src="/assets/fedex/images/custom-structures.jpg" class="promo-image p-3" alt="" />
          <h5>Custom structural enhancements</h5>
          <br />
          Partner with our skilled structural engineers to incorporate features like window cutouts or internal
          components for product display and protection.
        </div>
      </div>
    </div>
  </div>

  <div class="my-5">
    <div class="text-center mt-5 mb-3">
      <h2>How It Works</h2>
    </div>

    <div class="container">
      <div class="row">
        <div class="col-4">
          <div class="text-center">
            <img src="/assets/fedex/images/ecommerce-icon.png" class="steps-icon p-3" alt="" />
          </div>
          <strong>1. Brief</strong><br />
          <span style="color: black"
            >Start by answering a few questions to help our designer understand your design needs We will then quote
            your price depending on the scope of the project.
          </span>
        </div>

        <div class="col-4">
          <div class="text-center">
            <img src="/assets/fedex/images/brainstorm-icon.png" class="steps-icon p-3" alt="" />
          </div>
          <strong>2. Collaborate</strong><br />
          <span style="color: black">
            Our graphic designers or structural engineers will connect with you and work to create a functional, yet
            creative concept.
          </span>
        </div>

        <div class="col-4">
          <div class="text-center">
            <img src="/assets/fedex/images/problem-solving-icon.png" class="steps-icon p-3" alt="" />
          </div>
          <strong>3. Finalize</strong><br />
          <span style="color: black"
            >We'll deliver final designs and even include one free revision to make sure you're blissfully happy.
          </span>
        </div>
      </div>
    </div>
  </div>
  <div class="purple-background my-3 mx-auto">
    <div class="content-container py-4">
      <div class="row">
        <div class="col-3 text-center mt-2">
          <h2 class="light">Simple Pricing</h2>
        </div>

        <div class="col-6 text-center">
          <div class="container">
            <div class="row">
              <div class="col-4 text-center">
                <h5 class="light">1/2 HOUR</h5>
                <h3>$75.00</h3>
              </div>

              <div class="col-4 text-center">
                <h5 class="light">1 HOUR</h5>
                <h3>$125.00</h3>
              </div>

              <div class="col-4 text-center">
                <h5 class="light">2 HOUR</h5>
                <h3>$250.00</h3>
              </div>
            </div>
          </div>
        </div>

        <div class="col-3 text-center mt-2">
          <button class="orange-submit" (click)="scrollToBottom()">GET STARTED</button>
        </div>
      </div>
    </div>
  </div>

  <div class="my-5">
    <div class="text-center mt-5 mb-3">
      <h2>Your Options</h2>
    </div>

    <div class="container">
      <div class="row">
        <div class="col-12 col-lg-4">
          <div class="gray-background-border px-3 py-5 my-1 my-lg-0 mr-lg-1">
            <h3>Graphics</h3>

            <p>1:1 time with your graphic designer or customer success manager via email or phone call.</p>
            <p>Design artwork to fit the scope of your project.</p>
            <p>Adjust artwork, graphics, colors or fonts. We do color matching too!</p>
            <p>PDF of final design concept.</p>
            <p>1/2 hour minimum.</p>
          </div>
        </div>

        <div class="col-12 col-lg-4">
          <div class="gray-background-border px-3 py-5 my-1 my-lg-0 mx-lg-1">
            <h3>Structural</h3>

            <p>1:1 time with your structural designer or customer success manager via email or phone call.</p>
            <p>Send in products for proper fit and measurement if needed.</p>
            <p>Add carrying handles, window cutouts or inserts.</p>
            <p>3D Interactive file of final design concept.</p>
            <p>Option for a sample prototype to be sent upon completion.</p>
            <p>One hour minimum.</p>
          </div>
        </div>

        <div class="col-12 col-lg-4">
          <div class="gray-background-border px-3 py-5 my-1 my-lg-0 ml-lg-1">
            <h3>Graphics & Structural</h3>

            <p>
              1:1 time with your graphic designer and structural engineer or customer success manager via email or phone
              calls.
            </p>
            <p>Design artwork to fit the scope of your project.</p>
            <p>Adjust artwork, graphics, colors or fonts. We do color matching too!</p>
            <p>Add carrying handles, window cutouts or inserts.</p>
            <p>Send in products for proper fit and measurement if needed.</p>
            <p>PDF and 3D Interactive file of final design concept.</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="cta-block gray-background mt-1 text-start faq">
    <div class="cta-background-container"></div>
    <div class="container content-container">
      <div class="row">
        <div class="col-12 col-md-4">
          <h2 class="text-start">Frequently Asked Questions</h2>
        </div>
        <div class="col-12 col-md-8">
          <div class="border-top border-bottom pt-4">
            <p>
              <a data-bs-toggle="collapse" href="#faq1" role="button" aria-expanded="false" aria-controls="faq1">
                <div class="float-end"><i class="fa-sharp fa-light fa-angle-right"></i></div>
                How much design time will I need?
              </a>
            </p>
            <div class="collapse" id="faq1">
              <div class="card card-body text-black">
                If you are looking for custom design consultation, please fill out the form on this page and our team
                will base the time off the full scope of your project.
              </div>
            </div>
          </div>

          <div class="border-bottom pt-4">
            <p>
              <a data-bs-toggle="collapse" href="#faq2" role="button" aria-expanded="false" aria-controls="faq2">
                <div class="float-end"><i class="fa-sharp fa-light fa-angle-right"></i></div>
                How do I get started with custom design services?
              </a>
            </p>
            <div class="collapse" id="faq2">
              <div class="card card-body text-black">
                Our Custom Design Shop process begins by filling out the design time form. Someone from our team will be
                in touch within 48 hours. Download the prep questions ahead of time.
              </div>
            </div>
          </div>

          <div class="border-bottom pt-4">
            <p>
              <a data-bs-toggle="collapse" href="#faq3" role="button" aria-expanded="false" aria-controls="faq3">
                <div class="float-end"><i class="fa-sharp fa-light fa-angle-right"></i></div>
                With structural designs, can i send my product in to ensure best fit?
              </a>
            </p>
            <div class="collapse" id="faq3">
              <div class="card card-body text-black">
                If a design will be built around a specific product(s), we encourage you to send a sample to us so we
                can be sure to create the best possible box. We’re happy to ship it back to you!
              </div>
            </div>
          </div>

          <div class="border-bottom pt-4">
            <p>
              <a data-bs-toggle="collapse" href="#faq4" role="button" aria-expanded="false" aria-controls="faq4">
                <div class="float-end"><i class="fa-sharp fa-light fa-angle-right"></i></div>
                How do you determine the length of my design shop project?
              </a>
            </p>
            <div class="collapse" id="faq4">
              <div class="card card-body text-black">
                If you are looking for custom design consultation, our team will work with you to learn more about your
                needs and then base the time off the full scope of your project.
              </div>
            </div>
          </div>

          <div class="border-bottom pt-4">
            <p>
              <a data-bs-toggle="collapse" href="#faq5" role="button" aria-expanded="false" aria-controls="faq5">
                <div class="float-end"><i class="fa-sharp fa-light fa-angle-right"></i></div>
                For design services, how will my final concept be delivered?
              </a>
            </p>
            <div class="collapse" id="faq5">
              <div class="card card-body text-black">
                Graphic designs will be delivered as a PDF showing inside and outside design. Structural designs will be
                sent as 3D rendering. If you paid for a sample, it will be delivered to the address you provided.
              </div>
            </div>
          </div>

          <div class="border-bottom pt-4">
            <p>
              <a data-bs-toggle="collapse" href="#faq6" role="button" aria-expanded="false" aria-controls="faq6">
                <div class="float-end"><i class="fa-sharp fa-light fa-angle-right"></i></div>
                Can I ask for changes after I receive my final design?
              </a>
            </p>
            <div class="collapse" id="faq6">
              <div class="card card-body text-black">
                For all design service projects, once you have received your final design, one free revision is included
                in the process.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="email-container">
    <div class="content-container py-5">
      <a id="email"></a>

      <div class="container content-container">
        <div class="row">
          <div class="col-12 col-md-4">
            <div class="container">
              <div class="row">
                <div class="col-12">
                  <h2>Ready to Get Started?</h2>
                  If you have an interesting project, or just need some help, reach out to us. We're available.
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-8">
            @if (emailSent) {
            <div style="min-height: 600px">
              <h3>Thank you</h3>
              We will be in contact.
            </div>
            } @if (!emailSent) {
            <div>
              <span class="required">*</span> indicates a required field
              <form name="email-services" class="contact-container" novalidate>
                <fieldset>
                  <div class="row mb-3">
                    <div class="col-12 col-lg-6 mx-0">
                      <mat-label>Name <span class="required">*</span></mat-label>
                      <input
                        matInput
                        name="first"
                        class="form-control"
                        placeholder="John"
                        [formControl]="firstNameControl"
                      />
                      <mat-label>First</mat-label>
                    </div>
                    <div class="col-12 col-lg-6 mx-0">
                      <mat-label>&nbsp;</mat-label>
                      <input
                        matInput
                        name="last"
                        class="form-control"
                        placeholder="Doe"
                        [formControl]="lastNameControl"
                      />
                      <mat-label>Last</mat-label>
                    </div>
                    @if (wasValidated && (firstNameControl.invalid || lastNameControl.invalid)) {
                    <div class="col-12 mx-0">
                      <div class="alert alert-danger m-1">Please let us know what we should call you.</div>
                    </div>
                    }
                  </div>
                  <div class="row mb-3">
                    <div class="col mx-0">
                      <mat-label>Email Address <span class="required">*</span></mat-label>
                      <input
                        matInput
                        name="email"
                        class="form-control"
                        placeholder="john.doe@gmail.com"
                        [formControl]="emailControl"
                      />
                      @if (wasValidated && emailControl.invalid) {
                      <div class="alert alert-danger m-1">We need to know how to contact you.</div>
                      }
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col mx-0">
                      <mat-label>Phone Number <span class="required">*</span></mat-label>
                      <input
                        matInput
                        name="phone"
                        type="phone"
                        class="form-control"
                        placeholder="(123) 456-7890"
                        [formControl]="phoneControl"
                      />
                      @if (wasValidated && phoneControl.invalid) {
                      <div class="alert alert-danger m-1">We need to know how to contact you.</div>
                      }
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col mx-0">
                      <mat-label class="form-label">Design Type <span class="required">*</span></mat-label>
                      <mat-select
                        [placeholder]="type ? type : 'Type of help needed'"
                        class="form-control"
                        [formControl]="typeControl"
                      >
                        <mat-option value="Graphics">Graphics</mat-option>
                        <mat-option value="Structural">Structural</mat-option>
                        <mat-option value="Graphics & Structural">Graphics & Structural</mat-option>
                      </mat-select>
                      @if (wasValidated && typeControl.invalid) {
                      <div class="alert alert-danger m-1">Please tell us what you need help with.</div>
                      }
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col mx-0">
                      <mat-label>Tell Us What You're Looking For <span class="required">*</span></mat-label>
                      <textarea
                        matInput
                        class="form-control"
                        placeholder="What can we help you with today?"
                        [formControl]="messageControl"
                      ></textarea>
                      @if (wasValidated && messageControl.invalid) {
                      <div class="alert alert-danger m-1">
                        Please describe in a few words what you are looking for help with.
                      </div>
                      }
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col mx-0">
                      <mat-label>Inspiration Images</mat-label>
                      <ngx-dropzone (change)="processImage($event)" accept="image/jpeg,image/jpg,image/png,image/gif">
                        <ngx-dropzone-label
                          ><img src="assets/cb/images/upload_art_grey.svg" class="me-2" alt="" /> DROP YOUR IMAGE(S) HERE OR
                          CLICK TO UPLOAD
                        </ngx-dropzone-label>
                      </ngx-dropzone>
                      @if (files.length > 0) {
                      <div>
                        Files: @for (file of files; track file; let i = $index) {
                        <div>
                          <div class="badge border bg-transparent p-3 text-primary" (click)="removeImage(file)">
                            {{ file.filename }}
                            <a href="javascript:" class="ms-2" (click)="removeImage(file)"
                              ><i class="fa-sharp fa-light fa-times-circle"></i
                            ></a>
                          </div>
                        </div>
                        }
                      </div>
                      }
                    </div>
                  </div>
                </fieldset>
                <button class="orange-submit" [disabled]="!imagesReady" (click)="send()">SEND</button>
              </form>
            </div>
            }

            <!--<pre>{{body | json}}</pre>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</app-page-content-wrapper>
